import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { visitsApi } from '../../api/lib/visits';

import { attachmentsKeys } from '@/features/visits/api/query-keys/attachments';
import { Attachment } from '@/features/visits/api/types/attachment';

export const useAttachments = (visitId: number) => {
  return useQuery<Attachment[], ApiError>({
    queryKey: attachmentsKeys.list(visitId),
    queryFn: () => visitsApi.fetchVisitAttachments(visitId),
  });
};
